/**
 * @author David Roman <david@inarix.com>
 * @file Description
 * @desc Created on 2020-12-21 7:36:07 pm
 * @copyright Inarix
 */
import { combineReducers } from "redux";

// Reducers

import {
  AuthReducer as Authentication,
  AuthState,
} from "./authentication/authentication";

import { layout as LayoutReducer, LayoutState } from "./layout";

import { Users as UsersReducer, UsersState } from "./users/users";
import { Devices as DevicesReducer, DeviceState } from "./fleet/devices";
import { Projects as ProjectsReducer, ProjectsState } from "./fleet/projects";
import {
  Locations as LocationsReducer,
  LocationsState,
} from "./fleet/locations";

import { MapRed as MapReducer, MapState } from "./map/map";
import {
  Dashboard as DashboardReducer,
  DashboardState,
} from "./dashboard/dashboard";
import { Actions as ActionsReducer, ActionsState } from "./fleet/actions";
import {
  DataSampleView as DataSampleViewReducer,
  DataSampleviewState,
} from "./data/dataSampleView";
import {
  CreateLocation as CreateLocationReducer,
  CreateLocationState,
} from "./location/createLocation";
import {
  CreateUsers as CreateUsersReducer,
  CreateUsersState,
} from "./users/createUsers";
import {
  CreateTables as CreateTablesUsersReducer,
  UserTablesState,
} from "./userGroups/userGroupsSliceMultipleTables";
import {
  MasterInfo as MasterInfoReducer,
  MasterInfoState,
} from "./masterInfoReducer/masterInfoSlice";

import { LicenseListState, LicensesReducer } from "./licenses/licenseList";

import {
  GrainWise as GrainWiseReducer,
  GrainWiseState,
} from "./grainTracker/grainTracker";

import {
  GrainWiseEdition as GrainWiseEditionReducer,
  GrainWiseEditionState,
} from "./grainTracker/grainTrackerEdition";

import {
  SingleLocationState,
  SingleLocation as SingleLocationReducer,
} from "./location/singleLocation";

import {
  ShareSiteState,
  ShareSite as ShareSiteReducer,
} from "./shareSite/shareSite";

import {
  ManagersUsersState,
  CreateManagers as CreateManagersReducer,
} from "./users/managersUsers";

import { DataViewsState, DataViewsReducer } from "./dataTable/dataViews";

import { DataTableState, DataTableReducer } from "./dataTable/data";
import {
  DataFiltersState,
  DataFiltersReducer,
} from "./dataTable/dataTableFilters";
import { DataExportState, DataExportReducer } from "./dataTable/dataExport";
import {
  SharedDataState,
  SharedDataReducer,
} from "./UnifiedSlices/SharedDataReducer";

import {
  DashboardFiltersReducer,
  DashboardFiltersState,
} from "./dashboard/dashboardFilters";

import {
  SharedResultReducer,
  SharedResultState,
} from "./data/sharedResult";

import {
  ManagerCreation as ManagerCreationReducer,
  ManagerCreationState,
} from "./users/managerCreation";

export interface State {
  Authentication: AuthState;
  LayoutReducer: LayoutState;
  SharedDataReducer: SharedDataState;
  UsersReducer: UsersState;
  MapReducer: MapState;
  DevicesReducer: DeviceState;
  LocationsReducer: LocationsState;
  ActionsReducer: ActionsState;
  DashboardReducer: DashboardState;
  ProjectsReducer: ProjectsState;
  DataSampleViewReducer: DataSampleviewState;
  CreateLocationReducer: CreateLocationState;
  CreateUsersReducer: CreateUsersState;
  CreateTablesUsersReducer: UserTablesState;
  MasterInfoReducer: MasterInfoState;
  LicensesReducer: LicenseListState;
  GrainWiseReducer: GrainWiseState;
  GrainWiseEditionReducer: GrainWiseEditionState;
  ShareSiteReducer: ShareSiteState;
  SingleLocationReducer: SingleLocationState;
  CreateManagersReducer: ManagersUsersState;
  DataTableReducer: DataTableState;
  DataFiltersReducer: DataFiltersState;
  DataExportReducer: DataExportState;
  DataViewsReducer: DataViewsState;
  DashboardFiltersReducer: DashboardFiltersState;
  SharedResultReducer: SharedResultState;
  ManagerCreationReducer: ManagerCreationState;
}

const rootReducer = combineReducers({
  Authentication,
  LayoutReducer,
  UsersReducer,
  MapReducer,
  DevicesReducer,
  LocationsReducer,
  ActionsReducer,
  DashboardReducer,
  ProjectsReducer,

  DataSampleViewReducer,
  CreateLocationReducer,
  CreateUsersReducer,
  CreateTablesUsersReducer,
  MasterInfoReducer,
  LicensesReducer,
  GrainWiseReducer,
  GrainWiseEditionReducer,
  ShareSiteReducer,
  SingleLocationReducer,
  CreateManagersReducer,
  DataTableReducer,
  DataFiltersReducer,
  DataExportReducer,
  DataViewsReducer,
  SharedDataReducer,
  DashboardFiltersReducer,
  SharedResultReducer,
  ManagerCreationReducer,
});

export default rootReducer;
